module.exports = __webpack_public_path__ + "img/success.6f4a24c1.svg";